import { render, staticRenderFns } from "./support-chatbot.html?vue&type=template&id=3c0f88c9&scoped=true&"
import script from "./support-chatbot.js?vue&type=script&lang=js&"
export * from "./support-chatbot.js?vue&type=script&lang=js&"
import style0 from "./support-chatbot.scss?vue&type=style&index=0&id=3c0f88c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f88c9",
  null
  
)

export default component.exports